import * as checkbox from "@zag-js/checkbox"
import {normalizeProps, useMachine} from "@zag-js/solid"
import {createMemo, createUniqueId, JSX, splitProps} from "solid-js"

export interface ZagCheckboxProps extends Partial<checkbox.Props> {
    children: (api: checkbox.Api) => JSX.Element;
}

export default function ZagCheckbox(props: ZagCheckboxProps) {
    const [_, zagProps] = splitProps(props, ["children"])
    const service = useMachine(checkbox.machine, {
        id: createUniqueId(),
        ...Object.keys(zagProps).reduce((acc, key) => {
            acc[key] = () => zagProps[key as keyof typeof zagProps]
            return acc
        }, {} as Record<string, () => any>),
    })
    const api = createMemo(() => checkbox.connect(service, normalizeProps))
    return <props.children {...api()}/>
}